// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2bM9m","buttons":"Footer_buttons__oEv98"};